import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FilterPipe} from '@app/shared/pipe';
import {UtilsInjectable} from '@app/shared';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';

const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-purchase-report',
  templateUrl: './purchase-report.component.html',
  styleUrls: ['./purchase-report.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    SelectDropDownModule,
    FilterPipe,
    ReportPdfComponent
  ]
})
export class PurchaseReportComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  purchase_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;
  total_amount = 0;
  vendor_id: any;
  vendor: any;
  vendor_options: any;
  vendor_data: any;
  term = '';

  constructor(
    private loaderService: LoaderService,
    public consultingService: ConsultingService,
    public report: ReportService,
    public utils: UtilsInjectable,
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.listPurchaseReport();
    this.getDropdowns();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  getVendor(data: any) {
    this.vendor_id = data['value'].VENDOR_ID;
  }

  public getDropdowns() {
    const postData = {
      vendor_id: ''
    }
    this.loaderService.display(true);
    this.consultingService.listVendor(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.vendor = result['data'];

        this.vendor_options = this.vendor;
        for (let index = 0; index < this.vendor_options.length; index++) {
          if (this.vendor_options[index].VENDOR_ID == this.vendor_id) {
            this.vendor_data = this.vendor_options[index];

          }
        }
      }
    });
  }

  public listPurchaseReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      vendor_id: this.vendor_id,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.report.listPurchaseReport(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.purchase_data = result['data'];
        let total_amount = 0;
        for (const item of this.purchase_data) {
          total_amount = total_amount + parseFloat(item.AMOUNT)
        }
        this.total_amount = total_amount
      } else {
        this.loaderService.display(false);
        this.purchase_data = [];
        this.total_amount = 0;
      }
    });
  }

  public ExportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
      dateNF: 'dd/mm/yyyy;@',
      cellDates: true,
      raw: true
    });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'Purchase' + new Date().getTime() + EXCEL_EXTENSION);

  }

}